// extracted by mini-css-extract-plugin
export default {"meal":"MealItems_meal__6Gifa","pic":"MealItems_pic__IvFZ1","description":"MealItems_description__2lEgu","price":"MealItems_price__ie+dY","image":"MealItems_image__68+B4"};